import { FieldValidator } from '@ov-suite/helpers-angular';
import { UserModel } from '@ov-suite/models-idm';
import { OvAutoService } from '@ov-suite/services';
import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class PinValidator implements FieldValidator<UserModel> {
  errorMessage = 'Pin Address already In Use';

  constructor(private readonly ovAutoService: OvAutoService) {}

  async validateCreate(user: UserModel) {
    return this.validate(user);
  }

  async validateUpdate(user: UserModel) {
    return this.validate(user);
  }

  async validate(user: UserModel): Promise<boolean> {
    if (!user.userPin) {
      return true;
    }

    return await this.validateUserPin(user);
  }

  async validateUserPin(user: UserModel): Promise<boolean> {
    if (user.id) {
      return await this.validateUpdateUserPin(user.id, user.userPin);
    } else {
      return await this.validateCreateUserPin(user.userPin);
    }
  }

  validateUpdateUserPin(id: number, pin: string): Promise<boolean> {
    return firstValueFrom(
      this.ovAutoService.apollo.query<boolean>({
        query: gql(`query checkUpdatePinInUse($id: Int!, $pin: String!) {
          checkUpdatePinInUse(id: $id, pin: $pin)
        }`),
        variables: {
          id,
          pin,
        },
      }),
    ).then(res => res.data['checkUpdatePinInUse']);
  }

  validateCreateUserPin(pin: string): Promise<boolean> {
    // Needs to check that the current user has this pin and email before we say the pin is already in use.
    return firstValueFrom(
      this.ovAutoService.apollo.query<boolean>({
        query: gql(`query checkPinInUse($pin: String!) {
          checkPinInUse(pin: $pin)
        }`),
        variables: {
          pin,
        },
      }),
    ).then(res => !res.data['checkPinInUse']);
  }

  async required(): Promise<boolean> {
    return false;
  }
}
